module.exports = __webpack_public_path__ + "static/media/off-white-intarsia-arrows-socks-omra_thumb.a0bc3103.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/mens/thumbs/off-white-intarsia-arrows-socks-omra_thumb.png
// module id = 270
// module chunks = 0